const userRoutes = [
  {
    path: '*',
    redirect: '/',
  }, {
    path: '/',
    name: 'user.landing',
    component: () => import(/* webpackChunkName: "user.landing" */ '../views/user/landing/'),
  }, {
    path: '/start',
    name: 'user.start',
    component: () => import(/* webpackChunkName: "user.start" */ '../views/user/start/'),
  }, {
    path: '/quiz',
    name: 'user.questions',
    component: () => import(/* webpackChunkName: "user.questions" */ '../views/user/questions/'),
  }, {
    path: '/report',
    name: 'user.report',
    component: () => import(/* webpackChunkName: "user.report" */ '../views/user/report/'),
  },
];

const adminRoutes = [
  {
    path: '/manage',
    redirect: '/manage/submissions',
  }, {
    path: '/manage/submissions',
    name: 'admin.submissions',
    component: () => import(/* webpackChunkName: "admin.submissions" */ '../views/admin/submissions/'),
  }, {
    path: '/manage/submissions/:id',
    name: 'admin.submissions.details',
    component: () => import(/* webpackChunkName: "admin.submissions.details" */ '../views/admin/submissions/details/'),
  }, {
    path: '/manage/normalisation-vectors',
    name: 'admin.normalisation-vectors',
    component: () => import(/* webpackChunkName: "admin.normalisation-vectors" */ '../views/admin/normalisation-vectors/'),
  }, {
    path: '/manage/normalisation-vectors/:id',
    name: 'admin.normalisation-vectors.details',
    component: () => import(/* webpackChunkName: "admin.normalisation-vectors.details" */ '../views/admin/normalisation-vectors/details/'),
  }, {
    path: '/manage/archetypes',
    name: 'admin.report-types',
    component: () => import(/* webpackChunkName: "admin.report-types" */ '../views/admin/report-types/'),
  }, {
    path: '/manage/archetypes/:id',
    name: 'admin.report-types.details',
    component: () => import(/* webpackChunkName: "admin.report-types.details" */ '../views/admin/report-types/details/'),
  }, {
    path: '/manage/users',
    name: 'admin.users',
    component: () => import(/* webpackChunkName: "admin.users" */ '../views/admin/users/'),
  },
];

module.exports = [
  ...userRoutes,
  ...adminRoutes,
];
